import { UserRank } from './types'

export const getRankPercent = (rank?: UserRank) => {
  switch (rank) {
    case 'dong': return 1
    case 'bac':
    case 'sat': return 2
    case 'vang': return 3
    case 'luc_bao': return 4
    case 'kim_cuong': return 5
    default: return 0
  }
}

export const rankDisplay: Record<UserRank | 'unknown', { label: string; threshold: number }> = {
  newbie: { label: 'Tân binh', threshold: 0 },
  dong: { label: 'Đồng', threshold: 500000 },
  bac: { label: 'Bạc', threshold: 2000000 },
  sat: { label: 'Bạc', threshold: 2000000 },
  vang: { label: 'Vàng', threshold: 10000000 },
  luc_bao: { label: 'Lục bảo', threshold: 50000000 },
  kim_cuong: { label: 'Kim cương', threshold: 200000000 },
  unknown: { label: 'Không xác định', threshold: 0 },
}
